import { Card, CardBody, Col  } from "reactstrap";
import { ARTICAL_DATA } from "../../../Data/Faq";
import { H3, P } from "../../../AbstractElements";

const Articals = () => {
  return (
    <>
      {ARTICAL_DATA.map((item) => (
        <Col xl="4" sm={item.sm} className="box-col-4" key={item.id}>
          <Card className="bg-subheader">
            <CardBody>
            <div className="d-flex faq-widgets">
                <div className="flex-grow-1">
                  <H3>{item.title}</H3>
                  <P>{item.paragraph}</P>
                </div>
                {item.icon}
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
};
export default Articals;
